import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query"

import { isRetriable } from "@/platform/api/errors"
import { isExpectedError } from "@/platform/observability/errors"
import { logger } from "@/platform/observability/logger"

const STALE_TIME_MS = 60_000
const MAX_ATTEMPTS = 3

const retryRetriable = (failureCount: number, error: unknown) => failureCount + 1 < MAX_ATTEMPTS && isRetriable(error)

export const createQueryClient = () =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (!isExpectedError(error)) logger.error("query.failed", { ...(typeof query.meta?.viewer === "string" ? { viewer: query.meta.viewer } : {}) }, error)
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        if (!isExpectedError(error)) logger.error("mutation.failed", undefined, error)
      },
    }),
    defaultOptions: {
      queries: { staleTime: STALE_TIME_MS, refetchOnWindowFocus: false, retry: retryRetriable },
    },
  })
